import en from '@/i18n/langs/en'
import fa from '@/i18n/langs/fa'

export default {
    en,
    fa
}